// Helper to populate form fields from local storage
const STORAGE_KEY = 'user_meta';

interface UserMeta {
  first_utm_source?: string;
  first_utm_medium?: string;
  first_utm_campaign?: string;
  first_utm_term?: string;
  first_utm_content?: string;
  visits?: number;
  pages?: number;
  first_seen?: string;
  // last_seen?: string;
  [key: string]: string | number | undefined;
}

export const setLocalStorageFormFields = (form: Element) => {
  try {
    const rawData = localStorage.getItem(STORAGE_KEY);
    if (!rawData) return;

    const userData: UserMeta = JSON.parse(rawData);

    // MAPPING CONFIGURATION
    const fieldMap: Record<string, string> = {
      first_utm_source: 'first_utm_source',
      first_utm_medium: 'first_utm_medium',
      first_utm_campaign: 'first_utm_campaign',
      first_utm_term: 'first_utm_term',
      first_utm_content: 'first_utm_content',
      pages: 'pages_viewed',
      visits: 'visits',
      first_seen: 'first_seen',
      // 'last_seen':  'last_seen',
    };

    // Populate form fields based on the mapping
    Object.keys(fieldMap).forEach((storageKey) => {
      const formFieldName = fieldMap[storageKey];

      // Check if we have data to populate
      if (userData[storageKey] !== undefined && userData[storageKey] !== null) {
        const field = form.querySelector(`input[data-name="${formFieldName}"]`) as HTMLInputElement;
        if (field) {
          const val = String(userData[storageKey]);
          field.setAttribute('value', val);
          field.value = val;
        }
      }
    });
  } catch (error) {
    console.error('Error populating local storage fields:', error);
  }
};
